import './bootstrap';

// Turbo
// import * as Turbo from "@hotwired/turbo"

// autoNumeric
import AutoNumeric from 'autonumeric';
window.AutoNumeric = AutoNumeric;

// tippy
import tippy from 'tippy.js'
import {hideAll} from 'tippy.js';
window.tippy = tippy;
window.tippyhideAll = hideAll;
// import 'tippy.js/dist/tippy.css';

// flatpickr
import flatpickr from "flatpickr";
import { ko } from "flatpickr/dist/l10n/ko.js"
// import 'flatpickr/dist/flatpickr.css';

import monthSelectPlugin from 'flatpickr/dist/plugins/monthSelect'
window.monthSelectPlugin = monthSelectPlugin;
// import 'flatpickr/dist/plugins/monthSelect/style.css';

// fuse
import Fuse from 'fuse.js'
window.Fuse = Fuse;

// sweetalert2
import Swal from 'sweetalert2'
window.Swal = Swal;

// html2canvas
import html2canvas from 'html2canvas'
window.html2canvas = html2canvas;

import Sortable from 'sortablejs';
window.Sortable = Sortable;
